module.exports = __webpack_public_path__ + "static/media/STPProjectPreview2w1100@2x.d92b1b68.webp";